"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    horticultural: {
        id: 'businessTypes.horticultural',
        defaultMessage: 'Horticultural',
        description: 'Horticultural business type',
    },
    industrial: {
        id: 'businessTypes.industrial',
        defaultMessage: 'Industrial',
        description: 'Industrial business type',
    },
    cooperative: {
        id: 'businessTypes.cooperative',
        defaultMessage: 'Cooperative',
        description: 'Cooperative business type',
    },
    governmentPublicUtility: {
        id: 'businessTypes.governmentPublicUtility',
        defaultMessage: 'Government/Public Utility',
        description: 'Government/Public Utility business type',
    },
    groundsCare: {
        id: 'businessTypes.groundsCare',
        defaultMessage: 'Grounds Care',
        description: 'Grounds Care business type',
    },
    fleetHire: {
        id: 'businessTypes.fleetHire',
        defaultMessage: 'Fleet Hire',
        description: 'Fleet Hire business type',
    },
    contractor: {
        id: 'businessTypes.contractor',
        defaultMessage: 'Contractor',
        description: 'Contractor business type',
    },
    educationalResearchInstitute: {
        id: 'businessTypes.educationalResearchInstitute',
        defaultMessage: 'Educational/Research Institute',
        description: 'Educational/Research Institute business type',
    },
    leisure: {
        id: 'businessTypes.leisure',
        defaultMessage: 'Leisure',
        description: 'Leisure business type',
    },
    farm: {
        id: 'businessTypes.farm',
        defaultMessage: 'Farm',
        description: 'Farm business type',
    },
    forestry: {
        id: 'businessTypes.forestry',
        defaultMessage: 'Forestry',
        description: 'Forestry business type',
    },
    constructionMunicipal: {
        id: 'businessTypes.constructionMunicipal',
        defaultMessage: 'Construction/Municipal',
        description: 'Construction/Municipal business type',
    },
    mediaPress: {
        id: 'businessTypes.mediaPress',
        defaultMessage: 'Media/Press',
        description: 'Media/Press business type',
    },
    other: {
        id: 'businessTypes.other',
        defaultMessage: 'Other',
        description: 'Other business type',
    },
});
exports.default = messages;
